import { useErrorHandler } from "~/composables/useErrorHandler.js";

export function useFinalSubmit() {
  const { $api } = useNuxtApp();
  const submitting = ref(false);
  const { handleError, validationErrors, resetErrors } = useErrorHandler();

  const submit = async (url, options = {}) => {
    submitting.value = true;

    resetErrors();

    try {
      const response = await $api.raw(url, {
        method: "POST",
        ...options,
        body: unref(options.body),
      });

      return {
        ok: true,
        status: response.status,
        data: response._data?.data || null,
        raw: response._data || null,
        error: null,
      };
    } catch (error) {
      if (!options.quiet) {
        handleError(error); // notifications / logging
      }

      return {
        ok: false,
        status: error.status || null,
        data: error.data || null,
        raw: error.data || null,
        error,
      };
    } finally {
      submitting.value = false;
    }
  };

  return { submit, submitting, validationErrors, resetErrors };
}
